export const facilities = [
               {
                              id: 1,
                              image: 'https://cdn-icons-png.flaticon.com/128/1720/1720131.png',
                              header: 'Active Learning',
                              Desc: 'Uniquely productivate real time collaboration idea-sharing after awesome quality vectors after'
               },
               {
                              id: 2,
                              image: 'https://cdn-icons-png.flaticon.com/128/1048/1048949.png',
                              header: 'Expert Teachers',
                              Desc: 'Uniquely productivate real time collaboration idea-sharing after awesome quality vectors after'
               },
               {
                              id: 3,
                              image: 'https://cdn-icons-png.flaticon.com/128/5790/5790602.png',
                              header: 'Strategic Location',
                              Desc: 'Uniquely productivate real time collaboration idea-sharing after awesome quality vectors after'
               },
               {
                              id: 4,
                              image: 'https://cdn-icons-png.flaticon.com/128/10397/10397165.png',
                              header: 'Full Day Programs',
                              Desc: 'Uniquely productivate real time collaboration idea-sharing after awesome quality vectors after'
               },
]